import React from 'react'
import { Modal, Checkbox, Select, Spin, Input} from 'antd'
import './styles.scss'

import ShareItem from './share-item'

export default ({files, recipients, on_share_files, expiration, password, loading, visible, use_weblink,
                  on_cancel, on_select, on_copy_link, on_generate_link,
                  on_select_all, select_all, on_recipient_change, channels,
                  channel, share_on_slack, on_channel_change, on_password_change, on_expiration_change}) => {

  const expirations = [
    {key:'1Hr',     value: 3600},
    {key:'2Hrs',    value: 7200},
    {key:'6Hrs',    value: 21600},
    {key:'12Hrs',   value: 43200},
    {key:'24Hrs',   value: 86400},
    {key:'1 Week',  value: 604800}
    //{key:'2 Weeks', value: 1209600}
  ]

  return <Modal title="Share Files"
                visible={visible}
                closable={false}
                className={'share-modal'}

                onOk={() => recipients.length && on_share_files(files.filter(f => f.share))}
                onCancel={() => on_cancel()}

                cancelText={'Cancel'}
                okText={'Share'}>

    <Spin spinning={loading}>
      <div className='share rowWrap'>

        <span>Please enter the recipient’s email address below.</span>

        <div>
          <div>
            <Checkbox checked={select_all} onChange={(e) => on_select_all(e.target.checked)}>Select All</Checkbox>
          </div>

          <div>
            {
              files.map((file, i) => {
                return <ShareItem key={i}
                                  file={file}
                                  use_weblink={use_weblink}
                                  on_select={on_select}
                                  on_copy_link={on_copy_link}
                                  on_generate_link={on_generate_link}
                />
              })
            }
          </div>
        </div>

        <div className={'share-options'}>
          <div style={{width: '100%'}}>
            <label>Share by emails (Separate Email Addresses with commas (,))</label>
            <Select
              mode="tags" open={false} size={'large'}
              placeholder="Please enter email recipients"
               dropdownMatchSelectWidth={false}
              tokenSeparators={[',', ' ']}
              value={recipients}
              onChange={on_recipient_change}/>
          </div>

          <div>
            <div>
              <label>Enter Password</label>
              <Input size={'large'}
                     className={'password-input'}
                     type='password'
                     placeholder='Enter Password'
                     value={password}
                     onChange={on_password_change}/>
            </div>

            <div>
              <label>Expiration</label>
              <Select
                size="large"
                dropdownMatchSelectWidth={false}
                placeholder="Select expiration time"
                value={expiration}
                onChange={on_expiration_change}>{
                expirations.map((exp, i) => (
                  <Select.Option key={exp.value} value={exp.value}>{exp.key}</Select.Option>
                ))
              }
              </Select>
            </div>
          </div>

          {/*{
              channels.length ?
                <div>
                  <label>Share on slack channel</label>
                  <Select
                    size="large"
                    dropdownMatchSelectWidth={false}
                    placeholder     = "Select slack channel to share the files"
                    value={channel}
                    onChange={on_channel_change}>{
                    channels.map((category, i) => (
                      <Select.OptGroup key={i} label={category.name}>
                        {category.channels.map(channel => <Option key={channel.id} value={channel.name}>{channel.name_normalized}</Option>)}
                      </Select.OptGroup>
                    ))
                  }
                  </Select>
                </div>:null
            }*/}
        </div>

        {/*<span>Separate Email Addresses with commas (,)</span>*/}
      </div>
    </Spin>
  </Modal>
}
